import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from 'src/app/core/service/translate.service';
import { ItsmeAuthenticationService } from 'luxtrust-cosi-api/api/itsmeAuthentication.service';
import { AuthenticationResponse } from 'luxtrust-cosi-api/model/authenticationResponse';
import { take } from 'rxjs/operators';
import { AlertService } from '../../../../services/services/alert-service';
import { AppService } from '../../../../services/services/app.service';
import { ItsmeAuthServiceType, ItsmeService } from '../../../../services/services/itsme.service';
import { ItsmeAuthComponent } from '../itsme-auth.component';

@Component({
  templateUrl: './itsme-auth-signup.component.html', styleUrls: ['./itsme-auth-signup.component.scss']
})
export class ItsmeAuthSignupComponent extends ItsmeAuthComponent implements OnInit {

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected appService: AppService,
              protected alertService: AlertService,
              protected translate: TranslateService,
              protected itsmeService: ItsmeService,
              protected itsmeAuthenticationService: ItsmeAuthenticationService) {
    super(ItsmeAuthServiceType.SIGN_UP, route, router, appService, alertService, translate, itsmeService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected takeAction(redirectUri: string, itsmeCode: string) {
    this.itsmeAuthenticationService.itsmeSignup(itsmeCode, redirectUri)
      .pipe(take(1))
      .subscribe((response: AuthenticationResponse) => this.success('ALERT.SIGN_UP_SUCCESS', '/dashboard', response.accessToken),
        _ => this.failure('ALERT.SIGN_UP_FAILED', '/login'));
  }

}
